import { sendAxiosRequest } from "@api/request.js";

// micelaneas
async function getMicelaneas() {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/micelaneas`;

  const config = {
    method: "get",
    url: url,
    headers: {
      Accept: "*/*",
    },
  };

  return await sendAxiosRequest(config);
}

export { getMicelaneas };
